import { render, staticRenderFns } from "./SuperTouch.vue?vue&type=template&id=11232790&"
import script from "./SuperTouch.vue?vue&type=script&lang=js&"
export * from "./SuperTouch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports